export default __webpack_public_path__ + "static/media/hm-sg-img.70bb7d18.webp";